import React, { useState } from 'react';
import styles from './FileInputSection.module.scss'; // Assuming you have a CSS module for styling
import { ImageViewModal } from 'src/components/Modals';
import CloudUploadIcon from 'src/assets/images/icons/CloudUploadIcon.svg';
import preview from 'src/assets/images/icons/preview.svg';
import { isEmpty } from 'src/api/Api';
import * as XLSX from 'xlsx';

export const FileInputSection = ({ name, onChange, editName, isEdited, fileURL, acceptTypes }) => {
	const [selectedFile, setSelectedFile] = useState(null);
	const [filePreview, setFilePreview] = useState(null);
	const [imageModalIsOpen, setImgModalIsOpen] = useState(false);

	// Show preview if it's an image
	const isImage = selectedFile && selectedFile?.type?.startsWith('image/');

	// Handle file change (either image or excel)
	const handleFileChange = (event) => {
		event.preventDefault();
		const file = event?.target?.files[0];

		if (file?.type?.startsWith('image/')) {
			setSelectedFile(file);
			setFilePreview(URL.createObjectURL(file)); // For file preview (name of the file)
			onChange(event); // Call the parent onChange handler
		} else if (file?.type?.includes('excel') || file?.type?.includes('spreadsheetml')) {
			setSelectedFile(file);
			
			// Read the Excel file and display its contents
			const reader = new FileReader();
			reader.onload = (event) => {
			  const binaryStr = event?.target?.result;
			  const wb = XLSX.read(binaryStr, { type: 'binary' });
	  
			  // Extract the first sheet and convert to JSON
			  const sheetName = wb.SheetNames[0];
			  const sheet = wb.Sheets[sheetName];
			  const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 }); // Convert sheet to JSON
	  
			  // Set preview data
			  setFilePreview(sheetData);
			};
			reader.readAsBinaryString(file);
			onChange(event); // Call the parent onChange handler
		}
	};

	// Handle file download before submission
	const handleDownloadFile = (event) => {
		event.preventDefault();
		if (selectedFile) {
		  const url = URL.createObjectURL(selectedFile); // Create an object URL for the selectedFile
		  const link = document.createElement('a');
		  link.href = url;
		  link.download = selectedFile?.name; // Use the original selectedFile name for download
		  link.click();
		  URL.revokeObjectURL(url); // Clean up the object URL after downloading
		}
	};

	return (
		<div className={styles['file-uploader']}>
			<span className={styles['file-name']}>
				{!isEdited && (selectedFile ? editName : 'No file chosen')}
				{(isEdited && selectedFile && editName) || (isEdited && fileURL && editName)}
				{isEdited && !fileURL && !selectedFile && 'No file chosen'}
			</span>

			{/* Show preview for image files */}
			{isEdited && !selectedFile && !isEmpty(fileURL) && (
				<div className={styles['options']}>
					<button
						className={styles['action-button']}
						onClick={() => setImgModalIsOpen(true)} // Open modal when preview button is clicked
					>
						<img
							src={preview}
							className={styles['preview-image']}
							alt="preview icon"
						/>
					</button>

					{/* Show Image preview modal */}
					<ImageViewModal
						src={fileURL}
						open={imageModalIsOpen}
						handleClose={() => setImgModalIsOpen(false)} // Close modal function
					/>
				</div>
			)}

			{/* Show for any file type */}
			{selectedFile && (
				<div className={styles['options']}>
					{/* <span className={styles['file-name']}>
						{selectedFile.name}
					</span> */}
					<button
						className={styles['action-button']}
						onClick={(event) => {
							event?.preventDefault();
							isImage ? setImgModalIsOpen(true) : handleDownloadFile(event);
						}} // Open modal when preview button is clicked
					>
						<img
							src={preview}
							className={styles['preview-image']}
							alt="preview icon"
						/>
					</button>

					{/* Ensure the modal only opens when the state is true */}
					<ImageViewModal
						src={filePreview}
						open={imageModalIsOpen}
						handleClose={() => setImgModalIsOpen(false)} // Modal close function
					/>
				</div>
			)}

			<label htmlFor={name} className={styles['file-input-label']}>
				{/* Upload Icon */}
				<img
					src={CloudUploadIcon}
					className={styles['upload-image']}
					alt="cloud upload icon"
				/>
				<input
					id={name}
					className={styles['file-input']}
					name={name}
					type="file"
					accept={acceptTypes} // Dynamically handle file types (Excel or Image)
					onChange={handleFileChange}
					style={{ display: 'none' }}
				/>
			</label>
		</div>
	);
};
